import {createFileRoute} from '@tanstack/react-router';

import {NewUserPage} from '@/modules/admin-users/pages/NewUserPage';

export const Route = createFileRoute('/_authenticated/admin/users/new')({
  component: NewUserPage,
});
